import { apiClient } from './api.client';
import { API_CONFIG } from '../config/api.config';

export interface UserProfile {
  profile_id: number;
  username?: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  company_id: number;
  company_name: string;
  address1?: string;
  address2?: string;
  country_id?: number;
  state_id?: number;
  city_id?: number;
  postal_code?: string;
  status: string;
  is_active: boolean;
  last_login?: string;
  role_id?: number;
  role_name?: string;
  role_level?: number;
  created_date?: string;
  assigned_locations: number[];
}

export interface UpdateProfileRequest {
  username?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  address1?: string;
  address2?: string;
  country_id?: number;
  state_id?: number;
  city_id?: number;
  postal_code?: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export interface UserPreferences {
  notifications_enabled?: boolean;
  language?: string;
  theme?: string;
}

class UserProfileService {
  /**
   * Get current user's profile
   */
  async getMyProfile(): Promise<UserProfile> {
    return await apiClient.get<UserProfile>('/users/me');
  }

  /**
   * Update current user's profile
   */
  async updateMyProfile(data: UpdateProfileRequest): Promise<void> {
    await apiClient.put('/users/me', data);
  }

  /**
   * Change current user's password
   */
  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await apiClient.put('/users/me/password', data);
  }

  /**
   * Check if username is available
   */
  async checkUsernameAvailability(username: string): Promise<{ success: boolean; message: string }> {
    return await apiClient.get<{ success: boolean; message: string }>(`/users/check-username?username=${encodeURIComponent(username)}`);
  }

  // Note: Preferences are managed via localStorage in ProfilePage component
  // Backend API endpoints for preferences not yet implemented
}

export const userProfileService = new UserProfileService();
export default userProfileService;
